<template>
    <div class="row">
        <div class="col-12 mx-auto">
            <div class="bg-card rounded border-0">
                <div class="card-header">
                    <div class="input-group">
                        <select class="form-select" v-model="week">
                            <option value="" disabled selected>{{ $trans.get('__JSON__.Select a Week') }}</option>
                            <optgroup :label="group" v-for="(items, group) in weeks">
                                <option :value="key" v-for="(label, key) in items">
                                    {{ label }}
                                </option>
                            </optgroup>
                        </select>
                        <select class="form-select" v-model="location" :disabled="! week">
                            <option value="" disabled selected>{{ $trans.get('__JSON__.Select a Location') }}</option>
                            <optgroup :label="group" v-for="(items, group) in locations">
                                <option :value="location.id" v-for="location in items">
                                    {{ location.name }}
                                </option>
                            </optgroup>
                        </select>
                        <select class="form-select" v-model="employee" :disabled="! location">
                            <option value="" selected>{{ $trans.get('__JSON__.All Employees') }}</option>
                            <option :value="employee.user_id" v-for="employee in employees">
                                {{ fullName(employee) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive" v-if="Object.keys(rows).length > 0">
                        <table class="table table-hover table-nowrap">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Employee') }}
                                </th>
                                <th scope="col" v-for="(day, date) in days">
                                    <strong>{{ $trans.get(`__JSON__.${day}`) }}</strong><br/>
                                    {{ date }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Total') }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(items, id) in rows">
                                <th>{{ findEmployee(id) }}</th>
                                <td v-for="(hours, date) in items">
                                    {{ (hours === 0) ? '-' : hours }}
                                </td>
                                <td>{{ subHours(items) }}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="8" class="text-end">
                                    <strong>{{ $trans.get('__JSON__.Total') }}</strong>
                                </td>
                                <td>{{ totalHours }}</td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center pb-5" v-else-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <div class="text-center pb-5" v-else>
                        <em>{{ $trans.get('__JSON__.No records found to show') }}</em>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WorkedHours',
    data() {
        return {
            loading: false,

            week: '',
            location: '',
            employee: '',

            rows: [],
            weeks: [],
            days: [],
            locations: [],
            employees: [],
        }
    },
    computed: {
        totalHours() {
            return Object.values(this.rows)
                .map(row => Object.values(row).reduce((sum, a) => sum + a, 0))
                .reduce((sum, a) => sum + a, 0)
        }
    },
    watch: {
        week() {
            if (this.location) this.fetchHours()
            if (this.location && this.employee) this.fetchHours()
        },
        location() {
            this.fetchEmployees()
            this.fetchHours()
        },
        employee() {
            this.fetchHours()
        },
    },
    methods: {
        fullName(employee) {
            return `${employee?.first_name} ${employee?.last_name}`
        },
        findEmployee(id) {
            return this.fullName(this.employees.find(current => current.user_id === id))
        },
        subHours(items) {
            return Object.values(items).reduce((sum, a) => sum + a, 0)
        },
        update() {
            console.log('fetch data from backend based on location, user and selected week')
        },
        fetchEmployees() {
            this.fetch({ type: 'employees', location: this.location }, response => this.employees = response.data.items)
        },
        fetchHours() {
            this.fetch({ type: 'hours', start_week: this.week, location: this.location, employee: this.employee }, response => {
                this.rows = response.data.items
                this.days = response.data.days
            })
        },
        fetch(data, closure) {
            this.loading = true
            axios.post('/api/hours', data).then(response => closure(response))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.loading = false)
        },
    },
    mounted() {
        this.loading = true
        axios.get('/api/hours').then(response => {
            const data = response.data
            this.weeks = data.weeks
            this.locations = data.locations
        }).finally(this.loading = false)
    },
}
</script>
